import { useState } from "react";
import { ChevronDown } from "lucide-react";
import Seo from "@/components/Seo";

const FAQS = [
  { q: "Is Jesus Just Us free to join?", a: "Yes. The Seeker tier is free forever. Optional paid tiers (Believer $9/mo, Disciple $19/mo) support the platform and unlock perks like video uploads, group creation, and pinned testimonies." },
  { q: "Who can join?", a: "Anyone — believers, seekers, churches, ministries, nonprofits, businesses, artists, musicians, volunteers, and more. Our 11 profile types let everyone introduce themselves accurately." },
  { q: "Is this just for one denomination?", a: "No. JJU is for the whole body of Christ. We don't take sides on secondary doctrines — we focus on Jesus, prayer, service, and love." },
  { q: "How do you keep the community safe?", a: "Every post, comment, and listing can be reported with one click. Our admin team reviews flags, removes harmful content, and may warn or suspend accounts that violate our community guidelines." },
  { q: "Will my prayer requests stay private?", a: "Prayer requests inside a private group are only visible to its members. Posts on the public feed are visible to all signed-in members. You can always delete your own posts." },
  { q: "Can I share music, photos, and videos?", a: "Yes — every signed-in member can attach photos, videos, MP3/audio files, documents (.pdf/.docx/.ipynb), and YouTube links to any post." },
  { q: "How do donations work?", a: "Donations go through Stripe (secure, PCI-compliant). You'll receive an email receipt immediately. Designate your gift to a specific program or fund the general Kingdom budget." },
  { q: "Can my church or ministry list with you?", a: "Yes — directory features (Church, Ministry, Nonprofit, Business) are being rolled out. Until then, you can create a member profile with your organization type and invite others to follow." },
  { q: "How do I delete my account?", a: "Contact us at the Contact page and we'll remove your account and all associated content within 7 days." },
];

function Item({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="jj-card overflow-hidden" data-testid={`faq-${q.slice(0, 20).replace(/\s+/g, '-').toLowerCase()}`}>
      <button onClick={() => setOpen(!open)} className="w-full p-5 flex items-center justify-between text-left">
        <span className="font-medium text-jjblue">{q}</span>
        <ChevronDown className={`h-4 w-4 text-burgundy shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-5 pb-5 text-sm text-[var(--jj-text-secondary)] leading-relaxed">{a}</div>}
    </div>
  );
}

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <Seo
        title="FAQ · Jesus Just Us"
        description="Common questions about Jesus Just Us: who can join, how moderation works, donations, prayer privacy, and more."
        path="/faq"
      />
      <div className="overline text-burgundy">Frequently asked</div>
      <h1 className="font-serif text-5xl text-jjblue mt-3">Common questions</h1>
      <p className="mt-4 text-[var(--jj-text-secondary)]">
        Don't see what you're looking for? <a href="/contact" className="text-burgundy font-medium">Reach out</a> or email{" "}
        <a href="mailto:connect@jesusjustus.us" className="text-burgundy font-medium hover:underline">connect@jesusjustus.us</a> — we'll answer personally.
      </p>
      <div className="mt-10 space-y-3">
        {FAQS.map((f) => <Item key={f.q} q={f.q} a={f.a} />)}
      </div>
    </div>
  );
}
